/**
 * Split a CMS policy body into sections.
 *
 * The body is plain text typed into a CMS textarea, so the markup is the
 * smallest that reads naturally there: sections are separated by a blank
 * line, and a section whose first line begins with "## " takes that line as
 * its heading. Anything else is a paragraph. No HTML is ever produced from
 * the text, so nothing typed in the CMS can inject markup.
 *
 * @param {string} body
 * @returns {{heading: string|null, text: string}[]}
 */
export function parsePolicy(body) {
  return String(body || '')
    .replace(/\r\n?/g, '\n')
    .split(/\n[ \t]*\n/)
    .map((block) => block.trim())
    .filter(Boolean)
    .map((block) => {
      const [first, ...rest] = block.split('\n');
      if (first.startsWith('## ')) {
        return { heading: first.slice(3).trim(), text: rest.join('\n').trim() };
      }
      return { heading: null, text: block };
    });
}
